import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import { KendoMatrixTable } from "./matrixtable_component.js"
import { Tooltip } from "./common_metadata.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import { Helper } from "../../core/util/helper.js";
import * as datasources from "../common_metadata/datasource.js"
import React from "react";
interface TableChartProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: TableChartState;
    settings: any;
}

export class TableChartComponent extends React.Component<TableChartProps, any>{
    constructor(props) {
        super(props);
        this.state = {};
    }

    getFirstNotEmpty = (seriesName, data) => {
        for (var i = 0; i < data.length; i++) {
            var name = data[i][seriesName];
            if (name != null) {
                return name;
            }
        }
    }

    handleDataChange = (data, pivotKeys) => {
        this.setState({ data: data, pivotKeys: pivotKeys });
    }

    endsWith = (str, suffix) => {
        if (!str || !suffix) {
            return false;
        }
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    handleChartDataBound = (chart) => {
        setTimeout(() => {
            var max = chart._plotArea.valueAxis.range().max;
            var min = chart._plotArea.valueAxis.range().min;
            var numberLines = chart._plotArea.axisY._gridLines.children.length;
            this.setState({ maxAxisValue: max, minAxisValue: min, numberLines: numberLines });
            this.forceUpdate();
        }, 50);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.data !== nextState.data
            || this.props.settings.pageSize != nextProps.settings.pageSize
            || JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)
            || this.props.queryParameter !== nextProps.queryParameter
            || this.state.maxAxisValue != nextState.maxAxisValue;
    }

    renderYAxis = () => {
        let height = this.props.settings.chartHeight ? Number(this.props.settings.chartHeight) : 600;
        var gridLines = [];
        var lineMargin = (height - 19) / (this.state.numberLines);
        var numberAxisValues = this.state.numberLines;
        for (var i = numberAxisValues; i >= 0; i--) {

            var currentAxisValue = (this.state.maxAxisValue - this.state.minAxisValue) / numberAxisValues * i + this.state.minAxisValue;
            var currentLineMargin = i == 0 ? 12 : (lineMargin - 20);
            let axisVal;

            if (this.state.maxAxisValue >= 1000) {
                axisVal = Math.ceil(currentAxisValue / 100) * 100;
            }
            else if (this.state.maxAxisValue >= 100) {
                axisVal = Math.ceil(currentAxisValue / 10) * 10;
            }
            else {
                axisVal = Math.round(currentAxisValue * 100) / 100
            }
            gridLines.push(<li key={currentAxisValue} style={{ marginBottom: currentLineMargin + "px", lineHeight: 1.4285, listStyle: "none" }}>{axisVal}</li>);
        }
        return gridLines;
    }

    createExportButton = () => {
        var url: any = this.props.settings.exportUrl;
        if (!url || !this.state.data) {
            return null;
        }
        else {
            var root = "";

            url = root + url + "?";
            var newParams = $.extend({}, this.props.queryParameter);
            newParams.__templateName = this.props.settings.exportTemplate;

            url += $.param(newParams);
            return (<div className="btn-group">
                <button type="button" className="btn btn-success dropdown-toggle no-print" data-toggle="dropdown">
                    Export <span className="caret"></span>
                </button>
                <ul className="dropdown-menu" role="menu">
                    <li><a href={url}>Excel</a></li>
                </ul>
            </div>);
        }
    }

    render() {

        if (!this.props.settings.chartSettings) {
            return null;
        }

        var pivotized = { pivotizedData: this.state.data || [], pivotKeys: this.state.pivotKeys || [] };
        const newChartSettings: any = {};
        Object.assign(newChartSettings, this.props.settings.chartSettings);
        var newData = pivotized.pivotizedData;
        delete newChartSettings.legend;
        newChartSettings.chartArea = { margin: { left: 0 } };

        const maxValueField = this.props.settings.maxValueField;
        const minValueField = this.props.settings.minValueField;

        let valueAxis: any = { visible: false };
        if (maxValueField && newData && newData.length > 0 && newData[0][maxValueField]) {

            valueAxis.max = newData[0][maxValueField];
        }

        if (minValueField && newData && newData.length > 0 && newData[0][minValueField]) {

            valueAxis.min = newData[0][minValueField];
        }

        newChartSettings.valueAxis = valueAxis;

        var autoSeriesList = newChartSettings.autoSeries;
        var seriesList = [];
        var seriesListChart = []
        var that = this;
        if (Array.isArray(autoSeriesList)) {
            autoSeriesList.map(function (autoSeries) {
                var stack = autoSeries.stack && autoSeries.stack.group && autoSeries.stack.group != "" ? { group: autoSeries.stack.group } : null;

                var fieldName = autoSeries.field;
                if (that.endsWith(fieldName, '*')) {

                    fieldName = fieldName.replace('*', '');
                    for (var d = 0; d < pivotized.pivotKeys.length; d++) {
                        var newSeries: any = {
                            pivotKey: pivotized.pivotKeys[d],
                            type: autoSeries.type,
                            field: fieldName + "_" + pivotized.pivotKeys[d],
                            colorField: autoSeries.colorField + "_" + pivotized.pivotKeys[d],
                            color: that.getFirstNotEmpty(autoSeries.colorField + "_" + pivotized.pivotKeys[d], newData),
                            visibleInLegend: false,
                            missingValues: "zero",
                            name: that.getFirstNotEmpty(autoSeries.name + "_" + pivotized.pivotKeys[d], newData),
                            style: autoSeries.style,
                            tableGroup: that.getFirstNotEmpty(newChartSettings.tableGroup + "_" + pivotized.pivotKeys[d], newData)

                        };

                        if (stack !== null) {
                            const groupingField = autoSeries.stack.uniqueGroupPerSeries;
                            if (groupingField) {
                                stack.group = stack.group + "_" + pivotized.pivotKeys[d];
                            }
                            newSeries.stack = stack;
                        }
                        seriesList.push(newSeries);

                        if (!autoSeries.hideInChart) {
                            seriesListChart.push(newSeries);
                        }
                    }

                    let sortList = that.props.settings.sortList;

                    let sortOrder = {};
                    if (sortList && sortList.length > 0) {
                        for (let i = 0; i < sortList.length; i++) {
                            sortOrder[sortList[i].name] = i;
                        }

                        seriesList = seriesList.sort(function (a, b) {
                            let sort = sortOrder[a.name] - sortOrder[b.name];
                            if (autoSeries.type == 'area') {
                                sort = sort * -1
                            }
                            return sort;
                        });
                    }
                }
                else {
                    var newSeries: any = {
                        type: autoSeries.type,
                        field: autoSeries.field,
                        colorField: autoSeries.colorField,
                        color: autoSeries.color,
                        missingValues: "zero",
                        visibleInLegend: false,
                        name: autoSeries.name,
                        style: autoSeries.style
                    };
                    if (stack !== null) {
                        newSeries.stack = stack;
                    }

                    seriesList.push(newSeries);

                    if (!autoSeries.hideInChart) {
                        seriesListChart.push(newSeries);
                    }
                }
            });
        }

        seriesListChart = seriesListChart.sort((a, b) => { return (a.pivotKey as string || '').localeCompare(b.pivotKey as string || '') });
        newChartSettings.series = seriesListChart;

        newChartSettings.series = seriesList;
        let newTableSettings = newChartSettings;
        let exportButton = this.createExportButton();
        let height = this.props.settings.chartHeight ? Number(this.props.settings.chartHeight) : 600;
        const groupPadding = newChartSettings.tableGroup ? 28 : 0;
        const axisLabel = this.props.metadataSettings.chartSettings && this.props.metadataSettings.chartSettings.axisLabel ? < tr > <div style={{ textAlign: "right" }}>{this.props.metadataSettings.chartSettings.axisLabel}</div></tr> : null;

        return (<react_components.ReactColumn width={this.props.metadataSettings.width} >
            <ErrorBoundary>
                <react_components.ReactDataPager titel={this.props.settings.titel}
                    uid={this.props.uid}
                    context={this.props.context}
                    dataUrl={this.props.settings.dataUrl}
                    dataSource={this.props.metadataSettings.dataSource}
                    dataSourceId={this.props.metadataSettings.dataSource ? this.props.metadataSettings.dataSource.getDataSourceIdentifier() : null}
                    enablePagging={true}
                    pageSize={Number(this.props.settings.pageSize)}
                    queryParameter={this.props.queryParameter}
                    headerContent={exportButton}
                    pivotProperties={this.props.settings.chartSettings.pivotProperties}
                    onVisibleDataChange={this.handleDataChange}>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            {axisLabel}
                            <tr>
                                <td style={{ width: (Number(this.props.settings.firstColumnWidth) + groupPadding) + "px", verticalAlign: "bottom" }}>
                                    <ul style={{ textAlign: "right" }}>
                                        {this.renderYAxis()}
                                    </ul>
                                </td>
                                <td style={{ paddingRight: Helper.getScrollBarHeight() - 4 }}>
                                    <react_components.KendoSimpleChart height={height} onDataBound={this.handleChartDataBound} settings={newChartSettings} values={newData} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <KendoMatrixTable data={newData} settings={this.props.settings} chartSettings={newTableSettings} />
                </react_components.ReactDataPager>
            </ErrorBoundary>
        </react_components.ReactColumn>)
    }
};

export class TableChartState extends propertyTypes.BaseComponentProps {

    private chartHeightMetadata = new propertyTypes.TextProperty("chartHeight", "Chart height");
    public chartHeight: string;

    private tableHeightMetadata = new propertyTypes.TextProperty("tableHeight", "Table height");
    public tableHeight: string;

    private titelMetadata = new propertyTypes.TextProperty("titel", "Title");
    public titel: string;

    private pageSizeMetadata = new propertyTypes.TextProperty("pageSize", "Page size");
    public pageSize: string;

    private dataUrlMetadata = new propertyTypes.ServiceSelectorProperty("dataUrl", "DataUrl", false, propertyTypes.DataSourceType.sql);
    public dataUrl: string;

    private firstColumnWidthMetadata = new propertyTypes.TextProperty("firstColumnWidth", "First column width");
    public firstColumnWidth: string;

    private maxValueFieldMetadata = new propertyTypes.ColumnProperty("maxValueField", "Max value field", "dataUrl");
    public maxValueField: string;

    private minValueFieldMetadata = new propertyTypes.ColumnProperty("minValueField", "Min value field", "dataUrl");
    public minValueField: string;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private sortListMetadata = new propertyTypes.ObjectListPropertyExt("sortList", "Sort list")
        .addStateImplementation("default", SortName);
    public sortList: SortName[];

    private categoryAxisMetadata = new propertyTypes.ObjectPropertyExt("categoryAxis", "Category axis")
        .addStateImplementation("default", TableChartCategoryAxis);
    public categoryAxis: TableChartCategoryAxis[];

    private chartSettingsMetadata = new propertyTypes.ObjectPropertyExt("chartSettings", "Chart settings")
        .addStateImplementation("default", ChartSettings);
    public chartSettings: ChartSettings;

    public dataSource: datasources.Datasource;

    private tableChartMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.tableChartMetadata = baseMetaData.concat([this.chartHeightMetadata, this.tableHeightMetadata, this.titelMetadata, this.pageSizeMetadata, datasources.dataSourceMetadata, this.firstColumnWidthMetadata, this.maxValueFieldMetadata, this.minValueFieldMetadata, this.formatMetadata, this.sortListMetadata, this.categoryAxisMetadata, this.chartSettingsMetadata]);
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.tableChartMetadata;
    }
}

class ChartSettings extends propertyTypes.Serializable {
    private themeMetadata = new propertyTypes.SelectProperty("theme", "Theme").addOption("bootstrap", "Bootstrap").addOption("black", "Black").addOption("silver", "Silver");
    public theme: string;

    private tableGroupMetadata = new propertyTypes.TextProperty("tableGroup", "Table group field");
    public tableGroup: string;

    private axisLabelMetadata = new propertyTypes.TextProperty("axisLabel", "Axis label");
    public axisLabel: string;

    private pivotPropertiesMetadata = new propertyTypes.ObjectPropertyExt("pivotProperties", "Pivot properties")
        .addStateImplementation("default", PivotProperties);
    public pivotProperties: PivotProperties;

    private autoSeriesMetadata = new propertyTypes.ObjectListPropertyExt("autoSeries", "Auto series")
        .addStateImplementation("default", AutoSeries);
    public autoSeries: AutoSeries[];

    private seriesDefaultsMetadata = new propertyTypes.ObjectPropertyExt("seriesDefaults", "Series defaults")
        .addStateImplementation("default", SeriesDefaults);
    public seriesDefaults: SeriesDefaults;

    private tooltipMetadata = new propertyTypes.ObjectPropertyExt("tooltip", "Tooltip")
        .addStateImplementation("default", Tooltip);
    public tooltip: Tooltip;

    private categoryAxisMetadata: propertyTypes.BaseProperty[] = [this.themeMetadata, this.tableGroupMetadata, this.axisLabelMetadata, this.pivotPropertiesMetadata, this.autoSeriesMetadata, this.seriesDefaultsMetadata, this.tooltipMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.categoryAxisMetadata;
    }
};

class PivotProperties extends propertyTypes.Serializable {
    private pivotFieldMetadata = new propertyTypes.ColumnProperty("pivotField", "Pivot properties", "dataUrl");
    public pivotField: string;

    private groupingFieldsMetadata = new propertyTypes.ObjectListPropertyExt("groupingFields", "Grouping fields")
        .addStateImplementation("default", GroupingSortFields);
    public groupingFields: GroupingSortFields[];

    private sortFieldsMetadata = new propertyTypes.ObjectListPropertyExt("sortFields", "Sort fields")
        .addStateImplementation("default", GroupingSortFields);
    public sortFields: GroupingSortFields[];

    private pivotPropertiesMetadata: propertyTypes.BaseProperty[] = [this.pivotFieldMetadata, this.groupingFieldsMetadata, this.sortFieldsMetadata];
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.pivotPropertiesMetadata;
    }
}

class GroupingSortFields extends propertyTypes.Serializable {
    private fieldMetadata = new propertyTypes.ColumnProperty("field", "Field", "dataUrl");
    public field: string;

    private groupingFieldMetadata: propertyTypes.BaseProperty[] = [this.fieldMetadata];
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.groupingFieldMetadata;
    }
}

class AutoSeries extends propertyTypes.Serializable {
    private typeMetadata = new propertyTypes.SelectProperty("type", "Type").addOption("area", "Area").addOption("line", "Line").addOption("column", "Column");
    public type: string;

    private styleMetadata = new propertyTypes.SelectProperty("style", "Line style").addOption("smooth", "Smooth").addOption("step", "Step");
    public style: string;

    private fieldMetadata = new propertyTypes.TextProperty("field", "Field");
    public field: string;

    private colorFieldMetadata = new propertyTypes.TextProperty("colorField", "Color field");
    public colorField: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color");
    public color: string;

    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private hideInChartMetadata = new propertyTypes.CheckBoxProperty("hideInChart", "Hide in chart");
    public hideInChart: string;

    private stackMetadata = new propertyTypes.ObjectPropertyExt("stack", "Stack")
        .addStateImplementation("default", TableChartStack);
    public stack: TableChartStack;

    private groupingFieldMetadata: propertyTypes.BaseProperty[] = [this.typeMetadata, this.styleMetadata, this.fieldMetadata, this.colorFieldMetadata, this.colorMetadata, this.nameMetadata, this.hideInChartMetadata, this.stackMetadata];
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.groupingFieldMetadata;
    }
}

class TableChartStack extends propertyTypes.Serializable {

    private groupMetadata = new propertyTypes.TextProperty("group", "Group");
    public group: string;

    private uniqueGroupPerSeriesMetadata = new propertyTypes.CheckBoxProperty("uniqueGroupPerSeries", "Unique group per series");
    public uniqueGroupPerSeries: string;

    private tableChartStackMetadata: propertyTypes.BaseProperty[] = [this.groupMetadata, this.uniqueGroupPerSeriesMetadata];
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.tableChartStackMetadata;
    }
}

class SeriesDefaults extends propertyTypes.Serializable {
    private typeMetadata = new propertyTypes.SelectProperty("type", "Type").addOption("area", "Area").addOption("line", "Line").addOption("column", "Column");
    public type: string;

    private stackMetadata = new propertyTypes.CheckBoxProperty("stack", "Stack");
    public stack: boolean;

    private labelsMetadata = new propertyTypes.ObjectPropertyExt("labels", "Labels")
        .addStateImplementation("default", TableChartLabels);
    public labels: TableChartLabels;

    private seriesDefaultsMetadata: propertyTypes.BaseProperty[] = [this.typeMetadata, this.stackMetadata, this.labelsMetadata];
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.seriesDefaultsMetadata;
    }
}

class TableChartLabels extends propertyTypes.Serializable {
    private rotationMetadata = new propertyTypes.TextProperty("rotation", "Rotation");
    public rotation: string;

    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: boolean;

    categoryAxisLabelsMetadata: propertyTypes.BaseProperty[] = [this.rotationMetadata, this.visibleMetadata, this.templateMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.categoryAxisLabelsMetadata;
    }
}

class SortName extends propertyTypes.Serializable {

    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private sortNameMetadata: propertyTypes.BaseProperty[] = [this.nameMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.sortNameMetadata;
    }
}

class TableChartCategoryAxis extends propertyTypes.Serializable {
    private fieldMetadata = new propertyTypes.ColumnProperty("field", "Field", "dataUrl");
    public field: string;

    private categoryAxisMetadata: propertyTypes.BaseProperty[] = [this.fieldMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.categoryAxisMetadata;
    }
};